// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetHero_wrapper__3UyB-","bgColor":"WidgetHero_bgColor__2BUIh","message":"WidgetHero_message__ytUqz","username":"WidgetHero_username__WQrj_"};